import React, { useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ArrowBackIos } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import SidebarPlayback from "./app/SidebarPlayback";
import Sidebar from "./app/Sidebar";
import { playbackSidebar } from "slice/playbackSlice";
import NavbarMonitoring from "./app/Navbar";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { SearchIcon } from "@heroicons/react/outline";
import { RealTimeMonitoring } from "./app/RealTime/RealTimeMonitoring";
import { PlaybackMonitoring } from "./app/playback/PlaybackMonitoring";
import { subs, unsubscribeMessage } from "Config/natsClient";
import { clearTargetIsDpo } from "slice/targetIsDpoSlice";
import { clearTarget } from "slice/targetSlice";

const LayoutMonitoring = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathUrl = location.pathname;
  const isRealTime =
    pathUrl === "/monitoring" || pathUrl.startsWith("/monitoring/live");
  const navRef = useRef(null);
  // console.log(isRealTime, "isRealTime");

  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <div className="h-screen flex flex-col bg-black overflow-hidden">
      {/* Navbar */}
      <div ref={navRef} className="w-full">
        <NavbarMonitoring />
      </div>

      <div
        className="flex flex-row "
        style={{
          height: `calc(100% - ${navRef.current?.offsetHeight || 0}px)`,
        }}
      >
        {/* Sidebar */}
        <div
          id=""
          className={`relative transition-all duration-300 h-full ${
            showSidebar ? "w-custom-sidebar" : "w-5"
          } `}
          style={{
            transform: showSidebar ? "translateX(0%)" : "translateX(-100%)",
          }}
        >
          <div
            className={`flex flex-col h-full transition-opacity duration-300  ${
              showSidebar ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <div className="w-full flex justify-between items-center px-6 mt-4 mb-6 ">
              <img src="/asset/Logo_Putih.svg" alt="Logo" />
              <div onClick={() => setShowSidebar(false)}>
                <DehazeIcon className="cursor-pointer text-white" />
              </div>
            </div>

            <div className="w-full px-6">
              <NavLink
                to="/dashboard/home"
                className="flex border border-mo-text items-center justify-center px-4 py-2 gap-1 rounded-md text-sm font-medium text-mo-text"
                onClick={() => {
                  // console.log('first')
                  dispatch(playbackSidebar(0));
                  // dispatch(clearTargetIsDpo([]));
                  // dispatch(clearTarget([]));
                  unsubscribeMessage(subs);
                }}
              >
                <ArrowBackIos />
                <span>Kembali Ke Menu</span>
              </NavLink>
            </div>
            <div
              className={`transition-all duration-300 ${showSidebar ? "w-custom-sidebar" : "w-0 overflow-hidden"}`}
            >
              {isRealTime ? <Sidebar /> : <SidebarPlayback />}
            </div>
          </div>
        </div>

        {/* Tombol ☰ untuk memunculkan sidebar */}
        {!showSidebar && (
          <button
            className={`absolute top-[245px] sm:top-[245px] md:top-[200px] lg:top-[100px] left-4 text-white`}
            onClick={() => setShowSidebar(true)}
          >
            <DehazeIcon />
          </button>
        )}

        {/* Main Content */}
        <div
          id="content"
          className={`flex-1 max-h-full mt-5 overflow-y-auto ${showSidebar ? "" : "ml-6"} `}
        >
          {isRealTime ? <RealTimeMonitoring /> : <PlaybackMonitoring />}
        </div>
      </div>
    </div>
  );
};

export default LayoutMonitoring;
